import "core-js/modules/es.array.push.js";
import { Emitter } from '@/utils';
import { ApiEventNames } from '@/constants/common';
export const useApiForbiddenHandler = (loginPage = '/login', permErrPage = '/perm-error') => {
  const eventBus = new Emitter({}, 'api-event-bus');
  const router = useRouter();
  let offHandler = null;
  const handleForbiddenHandler = () => {
    const offLoginHandler = eventBus.on(ApiEventNames.Unauthorized, params => {
      return router.push({
        path: loginPage || '/login',
        replace: true
      });
    });
    const offPermHandler = eventBus.on(ApiEventNames.Forbidden, params => {
      return router.push({
        path: permErrPage || '/perm-error',
        replace: true
      });
    });
    return () => {
      offLoginHandler();
      offPermHandler();
    };
  };
  onMounted(() => {
    offHandler = handleForbiddenHandler();
  });
  onUnmounted(() => {
    if (offHandler) {
      offHandler();
      offHandler = null;
    }
  });
};